import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {TaskDurum} from "../../../enum/TaskDurum";
import {ITask} from "../GorevYoneticisiTypes";
import MtsTakipAc from "@/plugins/uyap-plugin/takip_ac/MtsTakipAc";
import {MtsXmlParser} from "@/plugins/uyap-plugin/takip_ac/MtsXmlParser";

export class MtsHizliTakipAcTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            let takip: MtsTakipAc = MtsTakipAc.fromJson(task.data);
            takip.parsedFile = MtsXmlParser.fromJson(task.data.parsedFile);
            await takip.takipBaslatYeni(false,true);
            task.response = takip;
            // UYAP'ta takip açıldı ama kart güncellenemediyse görev eksik biter.
            task.status = takip.icraProSenkronHatasi ? TaskDurum.BITTI_EKSIK : TaskDurum.BITTI_BASARILI;
            return task;
        } catch (e) {
            throw new Error(e.message)
        }
    }

}